import z from "zod";

export const reasonSchema = z.object({
  value: z.string().trim().min(8, 'Tamanho mínimo: 8 caracteres').max(1024, 'Tamanho máximo: 1024 caracteres'),
  file_attachment_attributes: z.object({
    blob_id: z.string().optional(),
    file: z.custom<File>().optional(),
  }, {message: 'Campo obrigatório'}),
});

export type ReasonValidationSchema = z.infer<typeof reasonSchema>;
